import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import type { ReactNode } from 'react'

export interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  title?: string
  onConfirm: () => void
  confirmLabel?: string
  cancelLabel?: string
  children: ReactNode
}

export function ConfirmDialog({
  open,
  onClose,
  title = 'Are you sure?',
  onConfirm,
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  children,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelLabel}</Button>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm()
            onClose()
          }}
          autoFocus
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
